import { archiveUserProfiles } from '../../../api'
import { USER_CONTRACTS_ENTITY } from '../../../constants/entity'
import { useInitData } from '../../../hooks'
import { getFlatProfilePathname } from '../../../utils/link'
import { useContractFormModal } from '../../Contract'
import { getEntityProfileSubTabCounters } from '../../Entity'
import { EntityTabContracts } from '../../EntityTab'
import { toUserSelectItem, useUserProfileContext } from '../../User'

import {
  USER_PROFILE_TAB_CONTRACTS_QA_NAME,
  USER_PROFILE_TAB_CONTRACTS_SCOPE_FILTER_KEY,
} from './UserProfileTabContracts.constants'

function UserProfileTabContracts({
  tabCounters,
  userData,
  onReloadTabCounters,
}) {
  const {
    handleCloseModal,
    handleEntityReload,
    registerContractsTabReload,
    setModal,
  } = useUserProfileContext()

  const { handleOpenCreation, handleOpenEdit } = useContractFormModal()

  const { availableSections } = useInitData()

  const initialUser = userData ? toUserSelectItem(userData) : null

  function getContractRowLink(item) {
    return item.flat?.id
      ? getFlatProfilePathname({ availableSections, id: item.flat.id })
      : null
  }

  function handleCreate({ onReloadList }) {
    handleOpenCreation({
      initialUser,
      setModal,
      onClose: handleCloseModal,
      onEntityReload: handleEntityReload,
      onReloadList,
    })
  }

  function handleEdit({ item, onReloadList }) {
    handleOpenEdit({
      contract: item,
      initialUser,
      setModal,
      onClose: handleCloseModal,
      onEntityReload: handleEntityReload,
      onReloadList,
    })
  }

  async function handleArchiveAllContracts({ scopeId }) {
    return archiveUserProfiles({ ids: [scopeId] })
  }

  return (
    <EntityTabContracts
      archiveAllApi={handleArchiveAllContracts}
      counters={getEntityProfileSubTabCounters(tabCounters)}
      entity={USER_CONTRACTS_ENTITY}
      getRowLink={getContractRowLink}
      qaName={USER_PROFILE_TAB_CONTRACTS_QA_NAME}
      scopeFilterKey={USER_PROFILE_TAB_CONTRACTS_SCOPE_FILTER_KEY}
      scopeId={userData?.id}
      setModal={setModal}
      onCloseModal={handleCloseModal}
      onCreate={handleCreate}
      onEdit={handleEdit}
      onEntityReload={handleEntityReload}
      onRegisterReload={registerContractsTabReload}
      onReloadCounters={onReloadTabCounters}
    />
  )
}

export default UserProfileTabContracts
